import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { useRef, useState } from "react";
import { addLacreRodoviario, removerLacreRodoviario, removerLacreRodoviarioTodos } from "../../../features/manifestoSlice";
import { LacreInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { getUuidV4, goToFocus } from "../../../utils/utils";
import { ButtonRemover, ButtonTrash, JTable, JTBody, JTHead } from "../../../components/Components";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";

const initialForm: LacreInterface = {
    id: 0,
    numero: ''
}

export default function LacresRodoviario() {
    const dispatch = useDispatch();
    const listaLacres = useSelector((state: RootState) => state.manifesto.manifesto.modal_rodoviario.lacres);
    const [form, setForm] = useState<LacreInterface>(initialForm);
    const numeroRef = useRef<HTMLInputElement>(null);
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();
    const [selecionado, setSelecionado] = useState<number | string>('');
    const validarPreenchimento = () => {

        if (form.numero.trim() === "") {
            goToFocus(numeroRef);
            alertModal('Informe o número do lacre.')
            return false;
        }

        if (listaLacres.find((item: LacreInterface) => item.numero === form.numero)) {
            goToFocus(numeroRef);
            alertModal('Número do lacre já foi adicionado.')
            return false;
        }

        return true;
    }

    const handleAdd = () => {
        if (validarPreenchimento()) {
            dispatch(addLacreRodoviario({
                id: getUuidV4(),
                numero: form.numero
            }));
            setForm(initialForm);
            goToFocus(numeroRef);
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id);
        const confirmed = await confirm({
            message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>,
            title: "Confirmação",
        })

        if (confirmed) {
            dispatch(removerLacreRodoviario(value.id));
            goToFocus(numeroRef);
        }
        setSelecionado('');
    }

    const removerTudo = async () => {
        if (listaLacres.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos ?</>,
                title: "Confirmação",
            })
            if (confirmed) {
                dispatch(removerLacreRodoviarioTodos());
                goToFocus(numeroRef);
            }
        }
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    return (<>

        <Row className="mb-3 g-2">
            <Col md={'auto'}>
                <Form.Group controlId="numero">
                    <Form.Label >* Número do lacre</Form.Label>

                    <InputGroup>
                        <Form.Control maxLength={60} type="text"
                            ref={numeroRef}
                            value={form.numero} name="numero" onChange={handleChange} />
                        <Button variant="primary"
                            onClick={handleAdd}><FontAwesomeIcon icon={faPlus} />
                        </Button>
                    </InputGroup>
                </Form.Group>
            </Col>
        </Row>

        <JTable>
            <JTHead>
                <tr>
                    <th className="text-center" style={{ width: '2.5rem' }}>
                        <ButtonTrash onClick={() => removerTudo()} icon={faTrashAlt} />
                    </th>
                    <th>Número do lacre</th>
                </tr>
            </JTHead>

            <JTBody>
                {listaLacres.map((item: LacreInterface) => (
                    <tr key={item.id} className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                        <td className="text-center">
                            <ButtonRemover onClick={() => handleRemover({ id: item.id, title: item.numero })} />
                        </td>
                        <td>{item.numero}</td>
                    </tr>
                ))}
            </JTBody>
        </JTable>
        {ConfirmModal}
        {ModalMessageEl}
    </>)
}
